/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable no-var */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */

import Usuario_FrontAPI, {UserRecord, IUserlist, UserUpdateParams, IRetornoAjaxUser} from './Usuario_FrontAPI';
import {initializeApp} from 'firebase/app';

import {getAuth, signInWithEmailAndPassword, signOut, onAuthStateChanged, User, sendPasswordResetEmail, IdTokenResult, ParsedToken} from 'firebase/auth';
import { IPropsFilterObj } from '../../componentes/tabelas/TableFilter';
import AppConfig from '../../AppConfig';

const app = initializeApp({
    apiKey: AppConfig.FIREBASE.config.apiKey,
    authDomain: AppConfig.FIREBASE.config.authDomain,
    projectId: AppConfig.FIREBASE.config.projectId,
    storageBucket: AppConfig.FIREBASE.config.storageBucket,
    messagingSenderId: AppConfig.FIREBASE.config.messagingSenderId,
    appId: AppConfig.FIREBASE.config.appId,
    measurementId: AppConfig.FIREBASE.config.measurementId?AppConfig.FIREBASE.config.measurementId:""   
});

const auth = getAuth(app);

declare global {
  var _USUARIO: User | null;
}

export interface CustomClaims {
    leitor?: boolean;
    administrador?: boolean;
}

export default class UserService extends Usuario_FrontAPI
{
    public user:User | null = null;
    
    public constructor()
    {
        super();
        this.user = window._USUARIO;
    }

    //#region [LOGIN,LOGOUT,TEST USER, GET TOKEN]

        async Login(email:string, password:string)
        {
            try
            {
                const userCredential = await signInWithEmailAndPassword(auth, email, password);
                
                this.user = userCredential.user;
    
                return this.user;
            }
            catch(error)
            {
                return error;
            }
        }

        async ExpLogin()
        {
            const token:string|undefined = await this.getToken();
            try
            {
                if(token){
                    return await this.usuarioExpiracaoSessao(token); 
                }
    
            }
            catch(error)
            {
                return error;
            }
        }

        async getToken()
        {
            if(this.user)
                return await this.user.getIdToken();
        }

        async getIdTokenResult(): Promise<ParsedToken | IdTokenResult | null>
        {
            return new Promise((res,rej) =>
            {
                onAuthStateChanged(auth, (currentUser) => 
                {
                    if(currentUser)
                    {
                        res(currentUser.getIdTokenResult().then(idTokenResult => idTokenResult))
                        // this.user = currentUser
                    }

                    rej(false)
                });
            })
        }

        async getPermissao()
        {
            const TokenResult:ParsedToken | IdTokenResult | null = await this.getIdTokenResult();
            let permissao:CustomClaims = TokenResult.claims as CustomClaims;
            return  permissao || null;
        }

        async ehLogado():Promise<User|null>
        {
            return new Promise((res,rej) =>
            {
                onAuthStateChanged(auth, (currentUser) => 
                {
                    if(currentUser)
                    {
                        res(currentUser)
                        this.user = currentUser
                    }

                    rej(false)
                });
            });
        }

        async resetPassword(email: string) //: Promise<{ status: boolean; mensagem: string } | null>
        {            
            try 
            {
                await sendPasswordResetEmail(auth, email);

                return 'Enviamos um email com instruções para redefinir sua senha.';
            }
            catch (error)
            {
                return error;
            }
        }

        async LogOut()
        {
            await signOut(auth);
            
            window.location.href = '/';
        }

    //#endregion

    //#region [LIST, EDITE, DELETE]

        async userList(pageSize?:number,pageToken?:string,uId?:string,dataFilter?:IPropsFilterObj)
        {
            try
            {
                const token:string|undefined = await this.getToken();

                if(token)
                {
                    const res = await this.usuarioListaAjax(token,pageSize,uId,pageToken,dataFilter);
                    
                    return res as IUserlist
                }
            }
            catch(e)
            {
                console.error("Ajax erro:");
                console.error(e);
            }
        }

        async userByID(uId:string)
        {
            try
            {
                const token:string|undefined = await this.getToken();

                if(token)
                {
                    const res = await this.usuarioListaAjax(token,undefined,undefined,uId);

                    return res.Data as unknown as User; 
                }
            }
            catch(e)
            {
                console.error("Ajax erro:");
                console.error(e);
            }
        }

        async userUpdate(uid:string,email:string,displayName?:string,password?:string,ehAdministrador?:boolean)
        {
            let retorno: IRetornoAjaxUser;

            let params:UserUpdateParams|{} = {};

            if(password) 
                params = {
                    uId: uid,
                    email: email,
                    displayName: displayName,
                    password: password,
                    ehAdministrador: ehAdministrador
                }
            else
                params = {
                    uId: uid,
                    email: email,
                    displayName: displayName,
                    ehAdministrador: ehAdministrador
                }
            
            try
            {
                const token:string|undefined = await this.getToken();

                if(token)
                {
                    retorno = await this.usuarioUpdateAjax(token,params);

                    return retorno;
                }
            }
            catch(e)
            {
                return e;
            }
        }

        async userDelete(uid:string)
        {
            let retorno: UserRecord|null|undefined; 
            let uId:string = uid;
            
            try
            {
                const token:string|undefined = await this.getToken();

                if(token)
                {
                    retorno = await this.usuarioDeleteAjax(token,uId);

                    return retorno;
                }
            }
            catch(e)
            {
                console.error("Ajax erro:");
                console.error(e);
            }
        }

    //#region [CREATE]

        async userCreate(displayName:string,email:string,password:string, ehAdministrador:boolean)
        {
            let retorno: IRetornoAjaxUser;

            try
            {
                const token:string|undefined = await this.getToken();

                if(token)
                {
                    retorno = await this.usuarioCreateAjax(token,displayName,email,password,ehAdministrador);

                    return retorno;
                }
            }
            catch(e)
            {
                return e;
            }
        }        
}